import { $ as e, C as t, F as n, L as r, S as i, h as a, i as o, ot as s, p as c, t as l, v as u, w as d, z as f } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as p } from "./i18n-lite-BcmwMblk.js";
import { t as m } from "./normalize-props-DNjMoRjC.js";
import "./llm-messages.ce-D7ca2ziA.js";
//#region src/webcomponents/pix-llm/locales/de-AT.json
var h = {}, g = { "pix-llm-prompt-select": {
	description: "once selected, the prompts are no longer available.",
	label: "Please, select one of the prompts"
} }, _ = {}, v = { "pix-llm-prompt-select": {
	description: "una vez seleccionadas, las opciones ya no estarán disponibles.",
	label: "Por favor, selecciona una de las indicaciones"
} }, y = {}, b = { "pix-llm-prompt-select": {
	label: "Sélectionner un des prompts",
	description: "une fois sélectionnés, les prompts ne sont plus disponibles."
} }, x = { "pix-llm-prompt-select": {
	description: "una volta selezionati, i suggerimenti non saranno più disponibili.",
	label: "Seleziona uno dei suggerimenti"
} }, S = {}, C = { class: "prompt-select" }, w = { class: "prompt-select__label" }, T = { class: "sr-only" }, E = { class: "prompt-select__options" }, D = ["disabled", "onClick"], O = /*#__PURE__*/ l(/* @__PURE__ */ d({
	__name: "LLMPromptSelect.ce",
	props: {
		messages: { type: Array },
		prompts: { type: Array },
		speed: { type: Number }
	},
	setup(o, { expose: l }) {
		let d = o, p = e(d.messages), m = e(d.prompts.map((e) => ({
			...e,
			disabled: !1
		}))), h = e(!1);
		function g() {
			p.value = d.messages, m.value = d.prompts.map((e) => ({
				...e,
				disabled: !1
			})), h.value = !1;
		}
		l({ reset: g });
		async function _(e) {
			let t = d.speed === 0 || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			if (p.value = [
				...p.value,
				{
					direction: "outbound",
					content: e.prompt
				},
				{
					direction: "inbound",
					content: t ? e.response : ""
				}
			], e.disabled = !0, t) return;
			let n = p.value.length - 1;
			h.value = !0;
			let r = e.response.split(/(\s+|<[^>]+>)/);
			for (let e of r) await new Promise((e) => {
				setTimeout(e, d.speed ?? 20);
			}), p.value = [...p.value], p.value[n].content += e;
			h.value = !1;
		}
		return (e, o) => {
			let l = f("llm-messages");
			return n(), u(c, null, [t(l, { messages: p.value }, null, 8, ["messages"]), a("div", C, [a("p", w, [i(s(e.$t("pix-llm-prompt-select.label")) + " ", 1), a("span", T, " \xA0" + s(e.$t("pix-llm-prompt-select.description")), 1)]), a("div", E, [(n(!0), u(c, null, r(m.value, (e, t) => (n(), u("button", {
				key: t,
				disabled: e.disabled || h.value,
				onClick: (t) => _(e)
			}, s(e.prompt), 9, D))), 128))])])], 64);
		};
	}
}), [["styles", [".sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}llm-messages{height:400px;display:block}.prompt-select{border-top:1px solid #253858;padding:16px 24px 24px;font-family:Roboto,sans-serif}.prompt-select__label{color:#253858;margin-top:0;font-weight:700}.prompt-select__options{flex-wrap:wrap;justify-content:left;gap:1rem;display:flex}.prompt-select__options>button{color:#130261;background:#cec3f4;border:1px solid #fff;border-radius:16px;padding:1rem 1.5rem;font-size:.875rem;box-shadow:0 4px 12px -4px #957ee833}.prompt-select__options>button:hover:not(:disabled){color:#fff;cursor:pointer;background:#9a8dc7}.prompt-select__options>button:disabled{cursor:not-allowed;color:#1010104d}"]]]);
//#endregion
//#region src/webcomponents/pix-llm/llm-prompt-select.ce.js
p.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": h,
	"./locales/en.json": g,
	"./locales/es-419.json": _,
	"./locales/es.json": v,
	"./locales/fr-BE.json": y,
	"./locales/fr.json": b,
	"./locales/it.json": x,
	"./locales/nl.json": S
}));
var k = o(O, { configureApp(e) {
	p.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(p);
} });
k.prototype.normalizeProps = (e) => ({
	...e,
	speed: m(e.speed)
}), window.customElements.define("llm-prompt-select", k);
//#endregion
